import React, { useState, useEffect} from 'react';


export default function InputNumber(props) {

    const [value, setValue] = useState(props.value??0);


        
    function increment() {
        const { max } = props;

        if (typeof max === 'number' && props.value >= max) return;
        
        valueChanged(value + 1);
    }

    function decrement() {
        const { min } = props;

        if (typeof min === 'number' && props.value <= min) return;

        valueChanged(value - 1);
    }

    function valueChanged(v) {
        setValue(v);
        props.onChange(v);
    }
    
    return (
        <div >
            <button type="button" className="btn btn-light" onClick={decrement}>&minus;</button>
            <span style={{display: 'inline-block', width: '30px', textAlign: 'center'}}>{props.value}</span>
            <button type="button" className="btn btn-light" onClick={increment}>&#43;</button>
        </div>
    )
    
}